import moment from 'moment';
import React, { Component } from 'react';

import { NumericalInput } from '../../shared';

import { formatThousands } from '../../../util';

class MeasureGoal extends Component {

  getGoalProps(){
    const { goalValue, goalTarget, frequency } = this.props.goal;

    const goalIsMonthly = frequency === 'monthly';

    // console.log('end date for monthly: ', this.props.endDate);

    const dateToAssignMonthFor = moment(this.props.anticipatedSubmissionDate || this.props.endDate || undefined);

    // console.log('dateToAssignMonthFor: ', dateToAssignMonthFor.calendar());

    if(goalIsMonthly){
      //monthly

      const currentMonthAbbreviation = dateToAssignMonthFor.format('MMM');

      if(goalValue === undefined || goalValue === '' || goalValue === 0){
        return {
          status: 'blank',
          text: `${currentMonthAbbreviation} Goal: ` + formatThousands(goalTarget),
        }
      }
      else if(goalValue >= goalTarget){
        return {
          status: 'good',
          text: `${currentMonthAbbreviation} Progress: ${formatThousands(goalValue)}/${formatThousands(goalTarget)}`,
        }
      }
      else{
        return {
          status: 'blank',
          text: `${currentMonthAbbreviation} Progress: ${formatThousands(goalValue)}/${formatThousands(goalTarget)}`,
        }
      }
    }
    else{
      //weekly

      if(goalValue === undefined || goalValue === '' || goalValue === 0){
        return {
          status: 'blank',
          text: 'Goal: ' + formatThousands(goalTarget),
        }
      }
      else if(goalValue >= goalTarget){
        return {
          status: 'good',
          text: `${Math.round((goalValue / goalTarget) * 100.)}% of Goal (${formatThousands(goalTarget)})`,
        }
      }
      else{
        return {
          status: 'bad',
          text: `${Math.round((goalValue / goalTarget) * 100.)}% of Goal (${formatThousands(goalTarget)})`,
        }
      }
    }
  }

  render(){

    const { description, goalValue, goalTarget, name } = this.props.goal;

    const goalProps = this.getGoalProps();

    return (
      <div className={`goal measure ${goalProps.status} ${goalTarget > 99999 ? 'wide-input' : ''}`}>
        <div className="description">{name}</div>
        <div className={'input-goal fs-block ' + (goalProps.status)}>{goalProps.text}</div>
        <NumericalInput className="fs-block" disabled={!this.props.editable} formatThousands={true} value={goalValue} onUpdate={this.props.update} />
      </div>
    );
  }
}

export default MeasureGoal;



// WEBPACK FOOTER //
// ./src/components/sprint/goalTemplates/measureGoal.js